module.exports = __webpack_public_path__ + "img/megaline.3672cc87.jpg";